import { Component, OnInit, Input } from '@angular/core';
import { ReportService } from '../report.service';
import { SharedService } from '../../../shared/shared.service';
import { Logger } from 'angular2-logger/core';

@Component({
  selector: 'app-report-doughnut',
  providers: [ReportService],
  templateUrl: './report-doughnut.component.html',
  styleUrls: ['./report-doughnut.component.scss']
})
export class ReportDoughnutComponent implements OnInit {
  public doughnutChartLabels: string[] = ['Tickets Attendes', 'Tickets in Wait', 'Tickets Close'];
  public doughnutChartData: number[] = [350, 450, 100];
  public doughnutChartType: string = 'doughnut';
  @Input() public type_report: any;
  @Input() public info: any;
  public state_report: Array<number>;
  public date_start_report: string;
  public date_end_report: string;
  public date: string;
  public data_info: any;
  public seriesName: any;
  @Input() public name_str:string;
  public inf:any;

  constructor(
    private _reportService: ReportService,
    private _sharedService: SharedService,
    private logger: Logger) {
    }

  ngOnInit() {
  }



  customizeLabel(point) {
    console.log(point);
    if (point.argument === 'others') {
      point.argument = 'Otros';
      point.argumentText = 'Otros';
      point.originalArgument = 'Otros';
      point.point.argument = 'Otros';
      point.point.initialArgument = 'Otros';
      point.point.originalArgument = 'Otros';
      point.point._dataItem.argument = 'Otros';
      this.seriesName = 'otros';
    }
    let percent_truncate = (point.percent * 100).toFixed(1);
    return point.argumentText + ': ' + point.valueText + ' (' + percent_truncate + '%' + ')' + '';
}

customizeLegend(val) {
  if (val.pointName === 'others') {
    return val.pointName = 'otros';
  } else {
    return val.pointName = val.pointName;
  }

}

customizeTooltip(arg) {
  let percent_truncate = (arg.percent * 100).toFixed(1);
  return { text: arg.argumentText + "<br>" + arg.valueText + ' ' + percent_truncate + "%" };
}

  // events
 /* public chartClicked(e: any): void {
    console.log(e);
  }

  public chartHovered(e: any): void {
    console.log(e);
  }*/

}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/report/report-doughnut/report-doughnut.component.ts